export default "__VITE_ASSET__35a98991__"